import './logo.scss'
import type { FC } from 'react'
import { NavLink } from 'react-router-dom-v7'
import { cmsDataService } from '@/content/services/cms.data.service'
import { navigationService } from '@/content/services/navigation.service'
import type { B2BHeaderAndFooterPropsApi } from '@/features/b2b/b2bHeaderAndFooter.models'

export const Logo: FC<{ isB2B?: boolean; b2bHeaderAndFooterData?: B2BHeaderAndFooterPropsApi }> = props => {
    const { isB2B, b2bHeaderAndFooterData } = props
    const { logo, b2bLogo } = cmsDataService.get()
    const homePage = navigationService.getPageUrl('Home')
    const b2bHomePage = b2bHeaderAndFooterData && b2bHeaderAndFooterData.b2BPage.url
    const b2bLogoConfig = b2bHeaderAndFooterData && b2bHeaderAndFooterData.logo.desktop

    return (
        <div className="logo">
            <NavLink to={isB2B ? b2bHomePage! : homePage}>
                <img
                    src={isB2B ? b2bLogoConfig : logo.url}
                    className="logo-image"
                    alt={isB2B && b2bLogo?.url ? b2bLogo.alt : logo.alt}
                />
            </NavLink>
        </div>
    )
}
